export const REACT_ROUTER_FUTURE = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};
